__turbopack_context__.v({
  "address": "AAB3Va_address",
  "addressLine": "AAB3Va_addressLine",
  "bookLabel": "AAB3Va_bookLabel",
  "contactDetails": "AAB3Va_contactDetails",
  "container": "AAB3Va_container",
  "divider": "AAB3Va_divider",
  "email": "AAB3Va_email",
  "formPanel": "AAB3Va_formPanel",
  "headline": "AAB3Va_headline",
  "intro": "AAB3Va_intro",
  "layout": "AAB3Va_layout",
  "layoutDivider": "AAB3Va_layoutDivider",
  "leftColumn": "AAB3Va_leftColumn",
  "mailLink": "AAB3Va_mailLink",
  "newBusiness": "AAB3Va_newBusiness",
  "newBusinessBody": "AAB3Va_newBusinessBody",
  "newBusinessContent": "AAB3Va_newBusinessContent",
  "newBusinessCta": "AAB3Va_newBusinessCta",
  "newBusinessDetails": "AAB3Va_newBusinessDetails",
  "newBusinessHeading": "AAB3Va_newBusinessHeading",
  "newBusinessLine": "AAB3Va_newBusinessLine",
  "newBusinessLineMuted": "AAB3Va_newBusinessLineMuted",
  "newBusinessLinkIcon": "AAB3Va_newBusinessLinkIcon",
  "newBusinessMedia": "AAB3Va_newBusinessMedia",
  "newBusinessPortrait": "AAB3Va_newBusinessPortrait",
  "newBusinessSection": "AAB3Va_newBusinessSection",
  "page": "AAB3Va_page",
  "pullQuote": "AAB3Va_pullQuote",
  "pullQuoteText": "AAB3Va_pullQuoteText",
  "quoteSection": "AAB3Va_quoteSection",
  "rightColumn": "AAB3Va_rightColumn",
});
